import {
  DataWorkshopEntityRaw,
  dataWorkshopEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataWorkshopsListResponseDTO {
  private static validation = Validate.compile(
    DataWorkshopsListResponseDTO.validationSchema()
  );

  constructor(readonly data: DataWorkshopsListResponseDTORaw) {
    Validate.assert(DataWorkshopsListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataWorkshops', 'count'],
      properties: {
        dataWorkshops: {
          type: 'array',
          items: dataWorkshopEntityRaw,
        },
        count: {
          type: 'number',
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER,
        },
      },
    };
  }
}

interface DataWorkshopsListResponseDTORaw {
  dataWorkshops: DataWorkshopEntityRaw[];
  count: number;
}
